const endpointByDomain: { [key: string]: string | undefined } = {
  "app.truetms.com": "https://api.truetms.com",
  "beta.truetms.com": "https://beta-api.truetms.com",
  "qa-lynks-web.tecafrik.com": "https://qa-api.truetms.com",
};

export const isQa = window.location.host !== "app.truetms.com";
export const stage =
  window.location.host === "app.truetms.com"
    ? "prod"
    : window.location.host === "beta.truetms.com"
    ? "beta"
    : "qa";

export const endpoint =
  process.env.REACT_APP_API_URL ||
  endpointByDomain[window.location.host] ||
  "https://qa-api.truetms.com";
